var _defs, _g, _path, _g2, _path2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 207.283,
    height: 109.947,
    viewBox: "0 0 207.283 109.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.965,
    y1: 0.832,
    x2: -0.102,
    y2: 1.502,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe579"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.004,
    y1: 0.658,
    x2: 1.055,
    y2: 0.325,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd71d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb200"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14813",
    "data-name": "Path 14813",
    d: "M1230.567,127.931l-104.512,9.045V96.945L1230.567,87.9Z",
    transform: "translate(-1126.056 -87.9)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.517,
    cy: 0.136,
    r: 2.878,
    gradientTransform: "matrix(0.213, -0.085, 0.003, 0.142, 0.406, 0.161)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046,
    stopColor: "#ba6b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#bb6f4e",
    stopOpacity: 0.973
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#c17a5d",
    stopOpacity: 0.894
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#ca8e74",
    stopOpacity: 0.761
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#d6a996",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#e7cbc0",
    stopOpacity: 0.345
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#faf5f3",
    stopOpacity: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15533",
    "data-name": "Group 15533",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, -1006.685, 23.531)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15521",
    "data-name": "Group 15521",
    transform: "translate(1010.171 -63.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14814",
    "data-name": "Path 14814",
    d: "M1223.351,15.537,1055.187,30.2l2.3-44.842,168.164-14.661Z",
    transform: "translate(-1043.749 43.177)",
    fill: "none",
    stroke: "#e7e7e7",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14815",
    "data-name": "Path 14815",
    d: "M1244.8,98.584l-104.3,9.993V61.34l104.3-9.993Z",
    transform: "translate(-1094.442 -5.097)",
    fill: "none",
    stroke: "#e7e7e7",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14791",
    "data-name": "Path 14791",
    d: "M1498.048-19.165l-7.4-5.3h9.619Z",
    transform: "translate(-1302.499 40.278)",
    fill: "none",
    stroke: "#e7e7e7",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14792",
    "data-name": "Path 14792",
    d: "M1492.06-63.861l7.549,4.789L1485.79-54.1Z",
    transform: "translate(-1299.608 63.861)",
    fill: "none",
    stroke: "#e7e7e7",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15514",
    "data-name": "Group 15514",
    transform: "translate(0 88.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14793",
    "data-name": "Path 14793",
    d: "M1058.762,171.827l-5.361-4.673,8.193-9.752Z",
    transform: "translate(-1042.695 -157.402)",
    fill: "none",
    stroke: "#e7e7e7",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14794",
    "data-name": "Path 14794",
    d: "M1029.71,167.694l-2.7-3.693,9.629-2.5Z",
    transform: "translate(-1027.015 -159.858)",
    fill: "none",
    stroke: "#e7e7e7",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15520",
    "data-name": "Group 15520",
    transform: "translate(1015.597 -43.254)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14798",
    "data-name": "Path 14798",
    d: "M1230.567,127.931l-104.512,9.045V96.945L1230.567,87.9Z",
    transform: "translate(-1091.29 -47.583)",
    fill: "url(#linear-gradient)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15515",
    "data-name": "Group 15515",
    transform: "translate(40.128 54.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14799",
    "data-name": "Path 14799",
    d: "M1147.7,160.584a8.105,8.105,0,0,1-3.6-.426,6.7,6.7,0,0,1-2.646-1.775,7.975,7.975,0,0,1-1.641-2.732,9.788,9.788,0,0,1-.547-3.311,11.39,11.39,0,0,1,.693-3.854,14.517,14.517,0,0,1,1.924-3.645,17.107,17.107,0,0,1,2.92-3.082,15.641,15.641,0,0,1,3.643-2.227,12.844,12.844,0,0,1,4.072-1.045,8.027,8.027,0,0,1,3.594.427,6.969,6.969,0,0,1,2.637,1.774,7.646,7.646,0,0,1,1.611,2.734,10.324,10.324,0,0,1,.537,3.312,11.284,11.284,0,0,1-.693,3.84,14.883,14.883,0,0,1-1.924,3.627,15.907,15.907,0,0,1-2.881,3.1,14.961,14.961,0,0,1-3.613,2.24A12.939,12.939,0,0,1,1147.7,160.584Zm1.172-5.31a5.225,5.225,0,0,0,2.568-.886,6.876,6.876,0,0,0,1.855-1.891,8.962,8.962,0,0,0,1.494-4.843,5.848,5.848,0,0,0-.352-2.03,2.877,2.877,0,0,0-1.133-1.423,3.1,3.1,0,0,0-2.021-.4,5.3,5.3,0,0,0-2.539.869,6.5,6.5,0,0,0-1.846,1.859,9.5,9.5,0,0,0-1.123,2.384,8.5,8.5,0,0,0-.381,2.443,5.555,5.555,0,0,0,.361,2.047,2.964,2.964,0,0,0,1.1,1.454A3.063,3.063,0,0,0,1148.874,155.274Z",
    transform: "translate(-1139.265 -132.123)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14800",
    "data-name": "Path 14800",
    d: "M1198.11,134.2l14.229-1.232-1.113,5.212-8.252.714-.762,3.621,6.68-.577-1.006,4.843-6.719.583-1.719,8.1-5.986.519Z",
    transform: "translate(-1171.465 -128.843)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14801",
    "data-name": "Path 14801",
    d: "M1240.11,130.526l14.238-1.233-1.1,5.216-8.252.713-.771,3.621,6.7-.58-1.016,4.845-6.719.582-1.719,8.1-5.977.519Z",
    transform: "translate(-1196.441 -126.643)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14802",
    "data-name": "Path 14802",
    d: "M1282.147,126.809l14.541-1.259-1.1,5.215-8.555.741-.654,3.066,7.3-.634-1.035,4.849-7.3.632-.742,3.436,8.838-.765-1.113,5.215-14.8,1.282Z",
    transform: "translate(-1221.415 -124.402)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14803",
    "data-name": "Path 14803",
    d: "M1321.74,145.321l4.629-21.778,9.57-.828a4.722,4.722,0,0,1,3.018.626,5.11,5.11,0,0,1,1.9,2.139,6.608,6.608,0,0,1,.664,2.924,7.265,7.265,0,0,1-.312,2.119,9.7,9.7,0,0,1-.879,2.079,10.615,10.615,0,0,1-1.348,1.909,11.464,11.464,0,0,1-1.787,1.614l2.617,7.633-6.748.585-2.129-6.381-1.807.156-1.416,6.686Zm11.836-12.706a1.133,1.133,0,0,0,.566-.259,2.657,2.657,0,0,0,.566-.653,4.151,4.151,0,0,0,.469-.974,3.923,3.923,0,0,0,.176-1.189,2.579,2.579,0,0,0-.127-.892,1.217,1.217,0,0,0-.361-.525.6.6,0,0,0-.459-.157l-3.164.275-.977,4.661Z",
    transform: "translate(-1247.692 -122.69)",
    fill: "#263238"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14804",
    "data-name": "Path 14804",
    d: "M1208.548,32.314,1040.384,46.975,1042.7,2.133l168.154-14.661Z",
    transform: "translate(-1040.384 12.528)",
    fill: "url(#linear-gradient-2)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15517",
    "data-name": "Group 15517",
    transform: "translate(5.706 9.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15516",
    "data-name": "Group 15516",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14805",
    "data-name": "Path 14805",
    d: "M1058,66.081a19.482,19.482,0,0,1-5.8-.384,15.654,15.654,0,0,1-4.971-1.879l4.951-7a4.28,4.28,0,0,0,.557.415,11.451,11.451,0,0,0,1.68.892,15.347,15.347,0,0,0,2.49.824,8.973,8.973,0,0,0,2.92.209,3.526,3.526,0,0,0,1.338-.318,1.273,1.273,0,0,0,.586-.567,1.629,1.629,0,0,0,.166-.66,1.1,1.1,0,0,0-.693-1.066,8.206,8.206,0,0,0-1.875-.64c-.752-.175-1.562-.393-2.412-.651a11.359,11.359,0,0,1-2.8-1.267A4.512,4.512,0,0,1,1052.5,52.2a5.121,5.121,0,0,1-.459-2.517,10.6,10.6,0,0,1,1.2-4.667,12.349,12.349,0,0,1,2.939-3.631,15.362,15.362,0,0,1,3.994-2.444,14.673,14.673,0,0,1,4.424-1.106,13.166,13.166,0,0,1,3.662.165,17.49,17.49,0,0,1,3.125.9q1.421.57,2.461,1.1l-4.873,6.607c.059,0-.1-.12-.449-.345a11.229,11.229,0,0,0-1.445-.739,13.873,13.873,0,0,0-2.09-.685,7.16,7.16,0,0,0-2.334-.183,3.328,3.328,0,0,0-1.045.262,1.972,1.972,0,0,0-.781.582,1.6,1.6,0,0,0-.312.941.979.979,0,0,0,.488.91,4.95,4.95,0,0,0,1.445.58c.625.163,1.328.362,2.119.6a18.467,18.467,0,0,1,3.252,1.224,5.155,5.155,0,0,1,2.129,1.854,5.272,5.272,0,0,1,.664,3.066,10.93,10.93,0,0,1-1.279,4.987,10.8,10.8,0,0,1-3.027,3.441,14.518,14.518,0,0,1-4.014,2.08A18.89,18.89,0,0,1,1058,66.081Z",
    transform: "translate(-1047.229 -26.562)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14806",
    "data-name": "Path 14806",
    d: "M1117.771,33.59l11.436-.986a5.924,5.924,0,0,1,3.8.807,6.181,6.181,0,0,1,2.334,2.739,8.456,8.456,0,0,1,.693,3.746,10.585,10.585,0,0,1-1.016,4.047,14.7,14.7,0,0,1-2.539,3.773,14.012,14.012,0,0,1-3.623,2.869,10.57,10.57,0,0,1-4.3,1.332l-4,.345-2.129,8.563-7.637.658Zm7.939,11.693a1.67,1.67,0,0,0,.752-.3,3.473,3.473,0,0,0,.791-.779,4.486,4.486,0,0,0,.635-1.266,6.144,6.144,0,0,0,.283-1.754,2.984,2.984,0,0,0-.146-1.178,1.131,1.131,0,0,0-.449-.557,1.006,1.006,0,0,0-.586-.123l-3.252.28-1.475,5.97Z",
    transform: "translate(-1085.996 -23.365)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14807",
    "data-name": "Path 14807",
    d: "M1179.21,27.309l18.574-1.6-1.68,6.678-10.918.942-.977,3.928,9.326-.8-1.562,6.208-9.326.8-1.113,4.4,11.279-.972-1.66,6.678L1172.237,55.2Z",
    transform: "translate(-1123.458 -19.15)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14808",
    "data-name": "Path 14808",
    d: "M1244.371,49.821a9.472,9.472,0,0,1-4.443-.578,8.193,8.193,0,0,1-3.252-2.353,10.4,10.4,0,0,1-1.924-3.6,12.708,12.708,0,0,1-.537-4.278,14.474,14.474,0,0,1,1-4.641,20.19,20.19,0,0,1,2.51-4.559,21.261,21.261,0,0,1,3.721-3.973,20.029,20.029,0,0,1,4.736-2.926,17.187,17.187,0,0,1,5.508-1.4,10.508,10.508,0,0,1,6.279,1.092,6.371,6.371,0,0,1,3.115,4.056l-6.846,4.665a3.191,3.191,0,0,0-.84-2,3.383,3.383,0,0,0-1.65-.877,6.381,6.381,0,0,0-1.924-.122,6.743,6.743,0,0,0-3.223,1.1,8.931,8.931,0,0,0-2.422,2.38,12.51,12.51,0,0,0-1.543,3.016,10.7,10.7,0,0,0-.605,3.012,7.1,7.1,0,0,0,.381,2.715,4.1,4.1,0,0,0,1.387,1.9,3.537,3.537,0,0,0,2.441.559,7.507,7.507,0,0,0,2.041-.5,7.817,7.817,0,0,0,2.09-1.238,7.221,7.221,0,0,0,1.719-2.109l5.313,3.195a13.444,13.444,0,0,1-3.477,3.722,20.005,20.005,0,0,1-4.746,2.579A17.7,17.7,0,0,1,1244.371,49.821Z",
    transform: "translate(-1161.255 -16.536)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14809",
    "data-name": "Path 14809",
    d: "M1304.63,17.883l7.637-.658-6.973,27.893-7.646.658Z",
    transform: "translate(-1199.942 -13.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14810",
    "data-name": "Path 14810",
    d: "M1340.652,13.6l7-.6,2.041,27.117-7.764.668.01-5.343-6.787.584-2.7,5.576-7.8.672Zm1.3,16.839V21.986l-4.268,8.825Z",
    transform: "translate(-1216.417 -11.346)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14811",
    "data-name": "Path 14811",
    d: "M1402.316,9.373l7.637-.658-5.312,21.215,11.719-1.01-1.67,6.678-19.346,1.667Z",
    transform: "translate(-1259.516 -8.715)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15519",
    "data-name": "Group 15519",
    transform: "translate(34.767 40.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15518",
    "data-name": "Group 15518",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14812",
    "data-name": "Path 14812",
    d: "M1208.548,99.173l-168.164,14.661,2.314,20.957,164.9-13.055Z",
    transform: "translate(-1075.149 -94.647)",
    fill: "url(#radial-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVar2);
export default __webpack_public_path__ + "static/media/Var2.e55351c44c1d1a3fbe5669e41ce56d87.svg";
export { ForwardRef as ReactComponent };